module.exports = __webpack_public_path__ + "img/webInfused_thumb.d596cb22.png";